export const MENUBAR_SELECTORS = {
   TABLE_DROPDOWN: '[data-dropdown-role="table"]',
   DATETIME_DROPDOWN: '[data-dropdown-role="datetime"]',
   FORMAT_DROPDOWN: '[data-dropdown-role="format"]',
   FONT_FAMILY_DROPDOWN: '[data-dropdown-role="font-family"]',
   FONT_SIZE_DROPDOWN: '[data-dropdown-role="font-size"]',
   TEXT_ALIGN_DROPDOWN: '[data-dropdown-role="text-align"]',
   LINE_HEIGHT_DROPDOWN: '[data-dropdown-role="line-height"]',
   TEXT_COLOR_DROPDOWN: '[data-dropdown-role="text-color"]',
   BACKGROUND_COLOR_DROPDOWN: '[data-dropdown-role="background-color"]',
   INVISIBLE_CHARACTERS_BUTTON: '[data-command="invisibleCharacters"]',
} as const;